import { IconArrowUpRight } from "@tabler/icons-react";
import Link from "next/link";
import { cn } from "../../../lib/utils";
import type { CalendarEvent } from "./types";

export type CalendarEventItemProps = {
    className?: string;
    event: CalendarEvent;
};

export function CalendarEventItem({ className, event }: CalendarEventItemProps) {
    return (
        <Link
            className={cn(
                "group/calendar-event relative flex items-center gap-1 rounded-lg px-1.5 py-1 text-white text-xs leading-tight",
                className
            )}
            href={event.href}
            style={{ backgroundColor: event.color ?? "var(--color-primary)" }}
        >
            <span className={cn("min-w-0 flex-1 truncate font-medium", event.badge?.length === 6 && "mr-12", event.badge?.length === 4 && "mr-9", event.badge?.length === 3 && "mr-8", event.badge?.length === 2 && "mr-6")}>{event.label}</span>
            {event.badge ? (
                <span className="absolute top-0 right-0 bottom-0 flex shrink-0 flex-col items-center justify-center pr-2 font-bold opacity-100 transition-delay-300 transition-opacity group-hover/calendar-event:opacity-0 group-hover/calendar-event:transition-delay-0">
                    {event.badge}
                </span>
            ) : null}
            <div className="absolute top-0 right-0 bottom-0 flex shrink-0 flex-col items-center justify-center pr-2">
                <IconArrowUpRight className="size-3.5 shrink-0 opacity-0 transition-delay-0 transition-opacity group-hover/calendar-event:opacity-100 group-hover/calendar-event:transition-delay-500" />
            </div>
        </Link>
    );
}
